import store from '@/store/index'
import * as userSettings from '@/store/accounts/usersSettings.helpers'

export default {}

/**
 * Returns the full state object.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['monitoring/widgetControlModule/get']
}

/**
 * Returns the open/close state of all the widgets
 *
 * @returns Object
 */
export const widgets = () => {
  return store.getters['monitoring/widgetControlModule/widgets']
}

/**
 * Returns the widget by name
 *
 * @returns Object
 */
export const getWidget = (name) => {
  return store.getters['monitoring/widgetControlModule/widgets'][name]
}

/**
 * Returns the preferred widget order (if displayed in lists for example)
 *
 * @returns Array
 */
export const getWidgetOrder = () => {
  return store.getters['monitoring/widgetControlModule/widgetOrder']
}

/**
 * Returns the widget's caption.
 *
 * @returns String
 */
export const getWidgetCaption = (name) => {
  return getWidget(name).caption
}

/**
 * Returns the widget's icon.
 *
 * @returns String
 */
export const getWidgetIcon = (name) => {
  return getWidget(name).icon
}

/**
 * Returns the widget's secondary icon.
 *
 * @returns String
 */
export const getWidgetSecondaryIcon = (name) => {
  return getWidget(name).secondaryIcon
}

/**
 * Returns true if the widget can be shown.
 *
 * @returns Boolean
 */
export const canShowWidget = (name) => {
  const widget = getWidget(name)
  return typeof widget === 'undefined' ? false : widget.canShow()
}

/**
 * Returns true if a right side widget is open
 *
 * @returns boolean
 */
export const isRightWidgetOpen = () => {
  return store.getters['monitoring/widgetControlModule/isRightWidgetOpen']
}

/**
 * Returns true if a left side widget is open
 *
 * @returns boolean
 */
export const isLeftWidgetOpen = () => {
  return store.getters['monitoring/widgetControlModule/isLeftWidgetOpen']
}

/**
 * Returns the width of the right side widget
 *
 * @returns integer
 */
export const rightWidgetWidth = () => {
  return store.getters['monitoring/widgetControlModule/rightWidgetWidth']
}

/**
 * Returns the width of the left side widget
 *
 * @returns integer
 */
export const leftWidgetWidth = () => {
  return store.getters['monitoring/widgetControlModule/leftWidgetWidth']
}

/**
 * Returns the current state change counter
 *
 * @returns integer
 */
export const changeCounter = () => {
  return store.getters['monitoring/widgetControlModule/changeCounter']
}

/**
 * Returns whether the specified widget is open or not.
 *
 * @param widget string Name of the widget
 *
 * @returns Boolean
 */
export const isOpen = (widget) => {
  const widgets = store.getters['monitoring/widgetControlModule/widgets']
  return widgets[widget].isOpen
}

/**
 * Returns the widget's width
 *
 * @returns boolean
 */
export const widgetWidth = (widget) => {
  const widgets = store.getters['monitoring/widgetControlModule/widgets']
  return widgets[widget].width
}

/**
 * Opens the specified widget.
 *
 * @param widget string      Name of the widget
 */
export const open = (widget) => {
  store.commit('monitoring/widgetControlModule/open', widget)
}

/**
 * Close the specified widget.
 *
 * @param widget string Name of the widget
 */
export const close = (widget) => {
  store.commit('monitoring/widgetControlModule/close', widget)
}

/**
 * Close all open widgets.
 */
export const closeAll = () => {
  store.commit('monitoring/widgetControlModule/closeAll')
}

/**
 * Calculates the left side position for the widget
 *
 * @param leftWidgetWidth integer The width of the left side widget
 *
 * @returns integer
 */
export const calcLeftWidgetPos = (leftWidgetWidth) => {
  // If a right side widget is open then this widget will be placed to
  // the left of it, else it will be placed where the right side widget
  // usually is
  if (isRightWidgetOpen()) {
    return (
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    ) - (leftWidgetWidth + rightWidgetWidth()) - 20
  } else {
    return (
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    ) - leftWidgetWidth - 10
  }
}

/**
 * Calculates the left side position for the widget
 *
 * @param rightWidgetWidth integer The width of the widget
 *
 * @returns integer
 */
export const calcRightWidgetPos = (rightWidgetWidth) => {
  return (
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  ) - rightWidgetWidth - 10
}

/**
 * Returns an array with all the widgets that should be
 * displayed on the toolbar according to the user's settings.
 *
 * @returns []
 */
export const getToolbarBtnSettings = () => {
  // TODO: Fix TripReplayWidget name
  // TripReplayWidget used to be called TripsWidget. We filter it out here
  // otherwise we may get errors. This should eventually be removed once all
  // users are on the new version or we have implemented a back-end fix for it.
  return userSettings.get('mon_toolbar_buttons', [
    'LiveTrackingWidget',
    'TripReplayWidget',
    'ZonesWidget',
    'RecentlyAccessedWidget',
    'FleetWidget',
    'FindClientsWidget',
    'FindVehiclesWidget',
    'FindUnitsWidget',
    'ToolsFindLocationWidget',
    'ToolsDirectionsWidget'
  ]).filter(widget => widget !== 'TripsWidget')
}



// WEBPACK FOOTER //
// ./src/store/monitoring/widgetControl.helpers.js